<div class="info__sales" *ngIf="allTopSales && allTopSales.length > 0">
    <div class="container mob">
        <h2 class="info__title title">{{ 'index.info.sales.title' | translate }}</h2>
        <div class="info__background">
            <div class="info__body">
                <div class="info__inner">
                    <div class="info__labels">
                        <div class="info__labels-item">{{ 'index.info.sales.labels.type' | translate }}</div>
                        <div class="info__labels-item">{{ 'index.info.sales.labels.time' | translate }}</div>
                    </div>
                    <div class="selectTab">
                        <ul class="tabs first-tab">
                            <li class="tabs__dropdown">
                                <select (ngModelChange)="updateTopSalesFilterType($event)" [(ngModel)]="topSalesFilter.type">
                                    <option [value]="null">{{ 'index.info.sales.tabs.all' | translate }}
                                    </option>
                                    <option [value]="creatureType.Oregon">{{ 'creature_types.oregon' |
                                        translate }}</option>
                                    <option [value]="creatureType.Moonbits">{{ 'creature_types.moonbits' |
                                        translate }}</option>
                                    <option [value]="creatureType.Sharkman">{{ 'creature_types.sharkman' |
                                        translate }}</option>
                                    <option [value]="creatureType.Zunnie">{{ 'creature_types.zunnies' |
                                        translate }}</option>
                                </select>
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.type = null; updateTopSalesFilter()">
                                {{ 'index.info.sales.tabs.all' | translate }}
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.type = creatureType.Oregon; updateTopSalesFilter()">
                                {{ 'creature_types.oregon' | translate }}
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.type = creatureType.Moonbits; updateTopSalesFilter()">
                                {{ 'creature_types.moonbits' | translate }}
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.type = creatureType.Sharkman; updateTopSalesFilter()">
                                {{ 'creature_types.sharkman' | translate }}
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.type = creatureType.Zunnie; updateTopSalesFilter()">
                                {{ 'creature_types.zunnies' | translate }}
                            </li>
                            <div class="tabs__background"></div>
                        </ul>
                        <ul class="tabs second-tab">
                            <li class="tabs__dropdown">
                                <select (ngModelChange)="updateTopSalesFilterPeriod($event)" [(ngModel)]="topSalesFilter.periodInDays">
                                    <option [value]="null">{{ 'index.info.sales.tabs.all' | translate }}</option>
                                    <option [value]="7">7D</option>
                                    <option [value]="30">30D</option>
                                </select>
                            </li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.periodInDays = null; updateTopSalesFilter()">{{
                                'index.info.sales.tabs.all' | translate }}</li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.periodInDays = 7; updateTopSalesFilter()">7D</li>
                            <li class="tabs__item"
                                (click)="topSalesFilter.periodInDays = 30; updateTopSalesFilter()">30D</li>
                            <div class="tabs__background"></div>
                        </ul>
                    </div>
                    <div class="tabs__inner first-content">
                        <div class="info__list tabs__content acitve">
                            <div class="info__item-box" *ngFor="let item of topSales; let i = index">
                                <a [routerLink]="['/', lang, 'marketplace','view', item.id]">
                                    <div class="info__item">
                                        <div class="info__item-left">
                                            <div class="info__item-num">{{i+1}}</div>
                                            <img class="info__item-img" [src]="item.imageUrl" [alt]="item.name"
                                                style="width: 100px;">
                                            <div class="info__item-character">
                                                <div class="info__item-rarity rarity"
                                                    [ngClass]="{'common': item.rarity == rarityType.Common, 'rare': item.rarity == rarityType.Rare, 'legendary': item.rarity == rarityType.Legendary}">
                                                    {{item.rarity | rarityName | translate}}</div>
                                                <div class="info__item-id">{{item.nftTokenId}}</div>
                                            </div>
                                        </div>
                                        <div class="info__item-right">
                                            <div class="info__item-price">
                                                <strong>${{item.tradeListing!.price}}</strong><span>Ξ
                                                    {{item.tradeListing!.price | ethPrice}}</span>
                                            </div>
                                            <div class="info__item-time">{{item.tradeListing!.buyghtAt! | timeAgo}}
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>